import { useAuth } from '../context/AuthContext';

const EN_GB = {
  'program':                     'programme',
  'Program':                     'Programme',
  'programs':                    'programmes',
  'Programs':                    'Programmes',
  'No programs yet':             'No programmes yet',
  'Delete this program?':        'Delete this programme?',
  'Create First Program':        'Create First Programme',
  'Edit Program':                'Edit Programme',
  'New Program':                 'New Programme',
  'Program assigned successfully!': 'Programme assigned successfully!',
  'Program Details':             'Programme Details',
  'Program Name *':              'Programme Name *',
  'Save Program':                'Save Programme',
  'Go to Programs':              'Go to Programmes',
  'Brand Color':                 'Brand Colour',
  'Used as the accent color on invoices.': 'Used as the accent colour on invoices.',
  'Use brand colors':            'Use brand colours',
  "Apply your brand color from Brand & Logo settings to this page's accent color": "Apply your brand colour from Brand & Logo settings to this page's accent colour",
};

export function useLocale() {
  const { trainer } = useAuth();
  const isUK = trainer?.unit_system === 'metric';

  function t(key) {
    if (isUK && EN_GB[key] !== undefined) return EN_GB[key];
    return key;
  }

  return { isUK, t };
}
